export const purchaseUrls = {
  salesSystem: 'https://www.compradigitalya.com/cart/42992398237767:1',
  salesWithAi: 'https://www.compradigitalya.com/cart/42992410198087:1',
}

export const testimonials = [
  {
    initials: 'SK',
    name: 'Sebastián K.',
    place: 'Tucumán · 26 años · Entrenador en plaza pública',
    text: 'La verdad pensé que era otro PDF con cosas que ya sabía. Pero cuando llegué al Tomo 4 y vi las clases armadas con tiempos, correcciones y todo, me di cuenta de que nunca había tenido eso organizado. La primera semana que lo usé mis alumnos me preguntaron si había hecho un curso nuevo.',
  },
  {
    initials: 'VM',
    name: 'Valeria M.',
    place: 'Córdoba · 31 años · Profesora de Educación Física',
    text: 'Soy profe de educación física y le tenía miedo a la calistenia porque no me formé específicamente en eso. Con el Tomo 2 entendí el sistema de progresiones y dejé de improvisar. Ahora tengo una respuesta clara para cada alumno según dónde está parado.',
  },
  {
    initials: 'GR',
    name: 'Gonzalo R.',
    place: 'Buenos Aires · 29 años · Coach de calistenia online',
    text: 'Lo que más me sorprendió fue el Bono 4. Yo corregía técnica pero no sabía exactamente qué decir. Ahora uso las frases del banco y mis alumnos entienden el error en el momento. Uno me dijo que aprende más en una clase mía que en un mes en el gimnasio.',
  },
  {
    initials: 'TL',
    name: 'Tamara L.',
    place: 'Rosario · 34 años · Entrenadora grupal al aire libre',
    text: 'Tenía grupos de 8 a 10 personas con niveles muy distintos y era un caos. Con la matriz del Bono 4 puse las tres variantes por ejercicio en una hoja y listo. Cada alumno elige la suya y yo puedo corregir, en vez de correr explicando ejercicios distintos.',
  },
  {
    initials: 'RA',
    name: 'Rodrigo A.',
    place: 'Mendoza · 38 años · Entrenador personal',
    text: 'Subí los precios de mis clases individuales después de usar las planillas del Tomo 5. Cuando mostraba el registro de cada sesión y los peldaños de progresión que llevaba, los alumnos entendían perfectamente por qué mi trabajo valía más.',
  },
]

export const tomos = [
  {
    icon: '📘',
    name: 'Biblioteca de Ejercicios',
    period: 'Técnica, errores y variantes',
    content: [
      'Más de 300 ejercicios con técnica, errores frecuentes y correcciones',
      'Variantes claras para adaptar cada ejercicio por nivel',
      'La referencia técnica para responder con seguridad en clase',
      'Indicaciones simples que tus alumnos entienden en el momento',
    ],
  },
  {
    icon: '📗',
    name: 'Progresiones Paso a Paso',
    period: 'Escaleras por habilidad',
    content: [
      '8 escaleras completas: flexiones, dominadas, fondos, sentadilla, L-Sit y más',
      'Cada peldaño tiene un estándar claro para saber cuándo avanzar',
      'Progresiones para handstand, pistol, core y fuerza base',
      'Un camino visible para que cada alumno vea su progreso',
    ],
  },
  {
    icon: '📙',
    name: 'Rutinas y Programas',
    period: 'Planificación lista para entregar',
    content: [
      'Programas de 2, 3, 4 y 5 días semanales',
      'Full body, tren superior, tren inferior y core',
      'Fuerza, resistencia y acondicionamiento sin empezar de cero',
      'Rutinas listas para alumnos de distintos objetivos',
    ],
  },
  {
    icon: '📕',
    name: 'Clases Listas para Dictar',
    period: 'Sesiones profesionales en minutos',
    content: [
      'Más de 60 clases de 30, 45 y 60 minutos',
      'Formatos individual y grupal con calentamiento, bloque principal y cierre',
      'Sistema de códigos para elegir una clase en 30 segundos',
      'Tiempos, correcciones y adaptaciones resueltas antes de llegar',
    ],
  },
  {
    icon: '📓',
    name: 'Herramientas para Entrenadores',
    period: 'Seguimiento y fidelización',
    content: [
      'Fichas de evaluación inicial y 10 test físicos',
      'Planillas de seguimiento que completás en cinco minutos',
      'Más de 100 desafíos para sostener motivación todo el año',
      'Una manera profesional de mostrar el valor de tu servicio',
    ],
  },
]

export const bonuses = [
  ['01', '⏱️', '100 Clases Express', 'Clases completas de 30, 45 y 60 minutos para individuales y grupos. Elegís con el sistema de códigos y empezás a dictar.', '$18.000'],
  ['02', '📅', '365 Rutinas Anuales', 'Una rutina para cada día del año, clasificada por nivel, objetivo y duración. Nunca más te quedás sin planificación.', '$15.000'],
  ['03', '🥗', 'Guía de Alimentación', 'Menús, recetas, hidratación y nutrición pre y post entrenamiento para acompañar a tus alumnos con claridad.', '$12.000'],
  ['04', '🗣️', 'Banco de Correcciones Técnicas', 'Más de 200 frases exactas para corregir en vivo, matriz de adaptación por nivel y árbol de decisión para grupos mixtos.', '$14.000'],
  ['05', '🧘', 'Guía de Movilidad y Recuperación', 'Más de 20 protocolos de calentamiento, activación y vuelta a la calma de 5, 8, 10 y 15 minutos.', '$12.000'],
] as const

export const faqs = [
  ['¿Sirve si recién empiezo como entrenador?', 'Sí. El Tomo 4 incluye clases listas desde el día uno. No necesitás años de experiencia para dictar una sesión profesional con este sistema.'],
  ['¿Cómo recibo el material?', 'Inmediatamente después del pago te llega un correo con el enlace de acceso. En menos de cinco minutos podés abrirlo desde celular, tablet o computadora.'],
  ['¿Funciona para clases al aire libre sin equipamiento?', 'Sí. Incluye clases y rutinas sin barras pensadas específicamente para plazas, parques y espacios abiertos.'],
  ['¿También funciona para grupos mixtos?', 'Sí. El Bono 4 incluye una matriz de tres niveles por ejercicio pensada para que todos entrenen dentro de una misma clase.'],
  ['¿Qué pasa si tengo alumnos principiantes?', 'Las progresiones empiezan desde la base. Podés identificar el peldaño adecuado y darle a cada alumno una variante segura y clara.'],
  ['¿Incluye rutinas para alumnos online?', 'Sí. El Tomo 3 tiene programas estructurados que podés adaptar y entregar a tus alumnos presenciales u online.'],
  ['¿El Manual Elite es solo para atletas avanzados?', 'Está diseñado para entrenadores que quieren programar habilidades avanzadas con criterio. Incluye Front Lever, Planche, Back Lever, Dragon Flag y Muscle-Up.'],
  ['¿Puedo imprimir las planillas y fichas?', 'Sí. Todo el material está en PDF y podés imprimir fichas de evaluación, seguimientos, rutinas y protocolos para usarlos durante la clase.'],
  ['¿La garantía de 7 días es real?', 'Sí. Si dentro de los primeros siete días sentís que el material no es para vos, escribinos a compradigitalyaa@gmail.com y te devolvemos el 100% del dinero.'],
  ['¿Cuánto tiempo necesito para preparar una clase?', 'Con las clases, rutinas y códigos del sistema podés elegir una sesión adecuada en minutos. La idea es que llegues a entrenar, no a improvisar.'],
] as const

export const moreTestimonials = [
  {
    initials: 'LB',
    name: 'Luciana B.',
    place: 'La Plata · 27 años · Entrenadora de calistenia',
    text: 'Estaba a punto de dejar de dar clases porque sentía que no tenía suficiente para ofrecer. El Tomo 2 me hizo ver que el problema no era mi conocimiento: no tenía el sistema para organizarlo. Hoy tengo lista de espera.',
  },
  {
    initials: 'DP',
    name: 'Diego P.',
    place: 'Santa Fe · 33 años · Profe de calistenia y funcional',
    text: 'No soy de comprar cosas digitales, pero un colega me mostró sus planillas de seguimiento y se veía serio. Lo compré y en la primera semana ya tenía todo organizado de otra forma. Mis clases por fin se sienten profesionales.',
  },
  {
    initials: 'FC',
    name: 'Florencia C.',
    place: 'Neuquén · 30 años · Entrenadora grupal',
    text: 'El Bono 5 de movilidad fue lo que más me faltaba. Siempre era el momento en que más improvisaba. Ahora tengo el protocolo impreso, arrancamos diferente y terminamos diferente. Mis alumnos lo notaron enseguida.',
  },
  {
    initials: 'EM',
    name: 'Esteban M.',
    place: 'Mar del Plata · 36 años · Coach de fitness y calistenia',
    text: 'No esperaba tanto valor del Bono 3. Siempre me preguntaban qué comer y no sabía cómo responder sin pasarme de rol. Ahora les entrego la guía y explico los cinco principios básicos. Se sienten más acompañados y eso fideliza.',
  },
  {
    initials: 'NS',
    name: 'Nicolás S.',
    place: 'Salta · 24 años · Entrenador de street workout',
    text: 'Antes cada sesión era una mezcla de ejercicios que me venían a la cabeza. Ahora miro el nivel del alumno, abro la clase indicada y sé qué corregir. Gané confianza y también tiempo para crecer el grupo.',
  },
]
